import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import Link from "next/link";
import { useRouter } from "next/router";
import Nav from "./Nav";
import P0 from "./P0";
import P1 from "./P1";
import P2 from "./P2";
import P3 from "./P3";
import P4 from "./P4";
interface InstitutionsProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const Institutions: React.FC<InstitutionsProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  const { canEnterprise } = store.user;
  const [step, setStep] = useState(0);
  const [enterpriseApplyId, setEnterpriseApplyId] = useState("");
  /**useEffect */
  useEffect(() => {
    if (!canEnterprise) router.replace("/accounts/user/verification");
    store.user.getCountryInfo("XT_KYC");
  }, []);
  useEffect(() => {
    (document.scrollingElement || document.documentElement).scrollTop = 0;
  }, [step]);
  /**method */
  const onStart = (enterpriseApplyId: string) => {
    setEnterpriseApplyId(enterpriseApplyId);
    setStep(step + 1);
  };
  return (
    <div className={cx(styles["page-account-enterprise"], className)}>
      <div className={styles["iNav"]}>
        <Link href={"/accounts/user/verification"} replace>
          <a>&lt;&nbsp;{t("account.entAuth")}</a>
        </Link>
      </div>
      <div className={styles["iBody"]}>
        {step === 0 && <P0 onStart={onStart} />}
        {step !== 0 && <Nav step={step} />}
        {step === 1 && <P1 className={styles["iPage"]} onStepChange={setStep} enterpriseApplyId={enterpriseApplyId} />}
        {step === 2 && <P2 className={styles["iPage"]} onStepChange={setStep} enterpriseApplyId={enterpriseApplyId} />}
        {step === 3 && <P3 className={styles["iPage"]} onStepChange={setStep} enterpriseApplyId={enterpriseApplyId} />}
        {step === 4 && <P4 className={styles["iPage"]} />}
      </div>
    </div>
  );
};
export default observer(Institutions);
